<template>
	<router-link :to="href" :class="getButtonClass">
		<span v-html="text"></span>
		<svg class="icon" width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M10.0205 8.03749C10.0212 8.47882 9.83184 8.89882 9.50051 9.19015L2.06584 15.7308C1.54517 16.1682 0.768505 16.1002 0.331172 15.5788C-0.0914945 15.0748 -0.0434941 14.3275 0.439839 13.8822L6.94117 8.16282C7.01051 8.10215 7.01717 7.99682 6.95651 7.92749C6.95184 7.92215 6.94651 7.91682 6.94117 7.91215L0.43984 2.19282C-0.0808265 1.75548 -0.148827 0.978818 0.287839 0.458152C0.725173 -0.0625161 1.50184 -0.130515 2.02251 0.306152C2.03717 0.318151 2.05117 0.330817 2.06584 0.344151L9.49784 6.88282C9.82984 7.17482 10.0198 7.59549 10.0205 8.03749Z"/>
		</svg>
	</router-link>
</template>

<script>

	export default {

		props: {
			text: {
				type: String,
				default: 'Button',
			},
			type: {
				type: String,
				default: 'primary',
			},
			href: {
				type: String,
				default: '/',
			},
			shadow: {
				type: Boolean,
				default: false,
			},
			inline: {
				type: Boolean,
				default: false,
			},
		},

		computed: {

			getButtonClass: function() {

				var c = 'btn btn--' + this.type;
				if ( this.shadow ) {
					c += ' btn--shadow';
				}
				if ( this.inline ) {
					c += ' btn--inline';
				}
				return c;

			}

		}

	}

</script>

<style lang="scss">

	%btn {

	  @include typesize('small');
	  padding: $btn-padding;
	  border-radius: $btn-radius;
	  text-decoration: none;
	  appearance: none;

		transition: color .3s ease, background-color .3s ease, border-color .3s ease;

	}

	// Add/overwrite properties by re-declaring the 'btn' class from the framework.
	.btn {

	  @extend %btn;
	  display: block;
		text-align: center;

		&.btn--inline {
			display: inline-block;
		}

	  .icon {

	    margin: 0 0 0 .5rem;
	    width: .8em;
	    height: .8em;
	    fill: $blue-dark;

	  }

	}

	.btn--primary {

		outline: none;
		transform: scale(1);
		box-shadow: 0 0 0 0 rgba($black, 0);
		transition: transform .2s ease, box-shadow .3s ease;

	  &,
	  &:link,
	  &:visited {
	    color: $blue-dark;
	    border: 1px solid $white;
	    background-color: $white;
	  }

	  &:hover,
	  &:focus {
	    color: $blue-dark;
	    border: 1px solid $mist;
	    background-color: $mist-dark;
	  }

	  &:focus {
	    transform: scale(1.065);
	    box-shadow: 0 0 5px 1px rgba($black, .45);
	  }

	  &:active {
	    color: $blue-dark;
	    border: 1px solid $mist;
	    background-color: $mist;
	  }

	}

	// Secondary buttons.
	.btn--secondary {

		outline: none;
		transform: scale(1);
		box-shadow: 0 0 0 0 rgba($black, 0);
		transition: transform .2s ease, box-shadow .3s ease;	

		&[disabled] {
			opacity: .75;
		  &,
		  &:link,
		  &:visited,
		  &:hover,
		  &:focus,
		  &:active {
		    border: 1px solid $grey;
		    background-color: $grey;
		  }			
		}

	  &,
	  &:link,
	  &:visited {
	    color: $white;
	    border: 1px solid $blue-dark;
	    background-color: $blue-dark;
	  }

	  &:hover,
	  &:focus {
	    color: $white;
	    border: 1px solid $blue;
	    background-color: $blue;
	  }

	  &:focus {
	    transform: scale(1.065);
	    box-shadow: 0 0 5px 1px rgba($black, .45);
	  }	  

	  &:active {
	    color: $white;
	    border: 1px solid $blue;
	    background-color: $blue;
	  }

	  .icon {

	  	fill: $white;

	  }

	}

	.btn--shadow {
		box-shadow: 0 2px 1rem rgba(0, 0, 0, .06), 0 0 .5rem rgba(0, 0, 0, .06);
	}

</style>